import { GET_RESTAURANT_MENU_BASE_URL} from "../constants";
import { useEffect, useState } from "react";
import useGetLocation from "./useGetLocation";

const useRestaurant = (restaurantId) => {

  const [restaurant, setRestaurant] = useState(null);

  const userLocation = useGetLocation();

  useEffect(() => {
    // call getRestaurantInfo function so it fetch api data and set data in restaurant state variable
    if(userLocation["lat"] && userLocation["lng"]){
      getRestaurantInfo();
    }
  }, [userLocation]);

  const getRestaurantInfo = async () => {
    try {
      // const response = await fetch(GET_RESTAURANT_MENU_BASE_URL + restaurantId);
      const response = await fetch(`${GET_RESTAURANT_MENU_BASE_URL}lat=${userLocation.lat}&lng=${userLocation.lng}&restaurantId=${restaurantId}`)
      const json = await response.json();

      // console.log(json);

      // console.log(json?.data?.cards);

      //setting restaurant Summary Data
      const restaurantSummary = json?.data?.cards
        ?.map((x) => x.card)
        ?.find(
          (x) =>
            x.card["@type"] ===
            "type.googleapis.com/swiggy.presentation.food.v2.Restaurant"
        )?.card?.info;

      //setting menu Items of restaurant

      const menuItemsData =
        json?.data?.cards
          ?.find((x) => x.groupedCard)
          ?.groupedCard?.cardGroupMap?.REGULAR?.cards.map((x) => x.card?.card)
          ?.filter(
            (x) =>
              x["@type"] ===
                "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory" ||
              x["@type"] ===
                "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory"
          ) || [];
          // ?.map((x) => x.itemCards)
          // ?.flat()
          // .map((x) => x.card?.info) || [];

      // Menu Items at this point may be containing Redundant Items, so remove redundancy
      // const uniqueMenuItems = [];

      // menuItemsData.forEach((item) => {
      //   if (!uniqueMenuItems.find((x) => x.id === item.id))
      //     uniqueMenuItems.push(item);
      // });

      setRestaurant({
        summary: restaurantSummary,
        menuItems: menuItemsData,
      });

      // console.log(menuItemsData);

      // console.log(restaurantSummary);
      // console.log(uniqueMenuItems);
    } catch (error) {
      console.log(error);
    }
  };

  //Return restaurant data
  return restaurant;
};

export default useRestaurant;
